import { Modal, Button } from 'antd';
import React, { useState, useEffect, useMemo, useContext } from 'react';
import { List, Typography } from 'antd';

interface Mensagem {
    messagemErro: string;
}

const ModalErro = (props: Mensagem) => {

    const { messagemErro } = props;

    const tratarTexto = (mensagemErro: string) => {

        var listMensagem = mensagemErro.split(";");

        if (listMensagem.length > 0) {

            return <List
                size="small"
                bordered
                dataSource={listMensagem}
                renderItem={item => <List.Item>{item}</List.Item>}
            />
        }

        return mensagemErro;
    }

    const getWidtModal = () => {
        return screen.width / 3;
    }

    function error() {
        Modal.error({
            title: 'Foram encontrado(s) o(s) seguinte(s) erro(s) no processo de CONSOLIDAR EXECUTADO',
            content: tratarTexto(messagemErro),
            width: getWidtModal()
        });
    }

    return (
        <Button onClick={error}>Erro</Button>
    );
}
export default ModalErro;

